import React from 'react';

const testimonialData = [
    {
        image: 'testimonial-01',
        name: 'Claire Kvant',
        designation: 'STMA',
        location: 'CO Miego, AD, USA', 
        description: '“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„',
       
    },
    {
        image: 'testimonial-02',
        name: 'Lydia Hawkins',
        designation: 'STMA',
        location: 'Bangladesh', 
        description: '“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„',
      
    },
    {
        image: 'testimonial-03',
        name: 'Samantha Meszaros',
        designation: 'STMA',
        location: 'Poland', 
        description: '“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„',
    },
    {
        image: 'testimonial-03',
        name: 'Titus Fredman',
        designation: 'Rogers High School',
        location: 'Poland', 
        description: '“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„',
    },
    {
        image: 'testimonial-03',
        name: 'Reese Gentry',
        designation: 'Rogers High School',
        location: 'Poland', 
        description: '“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„',
    }
]


const TestimonialOne = ({column , teamStyle}) => {
    return (
        <div className="row row--15">
            {testimonialData.map((data, index) => (
                <div className={`${column}`} key={index}>
                
                        <div className={`rn-box-card ${teamStyle}`}>
                            <div className="inner">
                                <figure className="thumbnail">
                                    {/* <img src={`./images/testimonial/${data.image}.jpg`} alt="Corporate React Template" /> */}
                                </figure>
                                <figcaption className="content">
                                    {/* <p className="description">{data.description}</p> */}
                                    <h2 className="title">{data.name}</h2>
                                    <h6 className="subtitle theme-gradient">{data.designation}</h6>
                                </figcaption>
                            </div>
                        </div>
         
                </div>
            ))}
        </div>
    )
}

export default TestimonialOne;
